import { IColumn } from '@repo/ui';
import { useLegends } from 'presentation/app/hooks/useLegends';

export const makeMissedActivitiesJustificationsReportColumns =
  (): IColumn[] => {
    const { getLegends } = useLegends();

    return [
      {
        title: 'Motivo',
        dataKey: 'reason',
      },
      {
        title: getLegends('ESTUDANTE', false),
        dataKey: 'student',
      },
      {
        title: 'Data da Justificativa',
        dataKey: 'justification_date',
      },

      {
        title: 'Agendamento',
        dataKey: 'schedule',
      },
      {
        title: getLegends('LOCAL_ESTAGIO', false),
        dataKey: 'place',
      },
      {
        title: 'Tarefa',
        dataKey: 'task',
      },
    ];
  };
